const LEGACY_EVENT_SCOPE_KEY = 'selectedEventId';

export const getEventScopeStorageKey = userId =>
  `selectedEventId:${userId || 'anonymous'}`;

export const readSelectedEventScope = (userId, fallback = 'all') => {
  if (typeof window === 'undefined' || !window.sessionStorage) return fallback;
  try {
    const scopedKey = getEventScopeStorageKey(userId);
    const scopedValue = window.sessionStorage.getItem(scopedKey);
    if (scopedValue) return scopedValue;

    const legacyValue = window.sessionStorage.getItem(LEGACY_EVENT_SCOPE_KEY);
    if (legacyValue) {
      window.sessionStorage.setItem(scopedKey, legacyValue);
      return legacyValue;
    }
  } catch {
    return fallback;
  }
  return fallback;
};

export const writeSelectedEventScope = (userId, value) => {
  if (typeof window === 'undefined' || !window.sessionStorage) return;
  try {
    const normalized = String(value || 'all');
    window.sessionStorage.setItem(getEventScopeStorageKey(userId), normalized);
    window.sessionStorage.setItem(LEGACY_EVENT_SCOPE_KEY, normalized);
  } catch {
    // Ignore storage failures.
  }
};
